export const REMOTE_OREGON_PLACE_ID = 'ChIJXd1PcUdfxFQR-h30DV0f0Uc';
